import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import { accounts } from "../../utils/appConstants";
import api from "../../utils/api";

const SpendingAverages = () => {
	const [accountDetails, setAccountDetails] = useState([]);
	const [manualGroups, setManualGroups] = useState([]);
	const navigate = useNavigate();

	const [data, setData] = useState([]);

	useEffect(() => {
		const fetchMonthlyData = async () => {
			try {
				const res = await api.get(`/money/AccountBalance/`);
				setData(res.data);
				//setData(res.data);
				//console.log(res.data);
			} catch (err) {
				console.log(err);
			}
		};
		fetchMonthlyData();
	}, []);

	useEffect(() => {
		const groupedAccounts = {};

		// Optional manual rollup config: edit names to match your account identifiers in appConstants
		const manualGroupConfigV1 = [
			{ name: "NL Credit Cards", accounts: ["NL: Chase - Sapphire Preferred", "NL: Chase - United Explorer", "NL: Chase - Freedom"] },
			{ name: "Business Credit Cards", accounts: ["NL: Chase - Ink Bold Preferred", "NL: Chase - United Business"] },
			{ name: "Business Checking", accounts: ["NL: Immerge Checking"] },
			{ name: "Business Savings", accounts: ["NL: Immerge Saving"] },
			{ name: "Erin Credit Cards", accounts: ["Erin: Chase - Sapphire Preferred", "Erin: PNC - Points Credit Card", "Erin: PNC - CashBack Credit Card"] },
			{ name: "NL Checking", accounts: ["NL: Checking - D100", "NL: Cash"] },
			{ name: "Erin Checking", accounts: ["Erin: PNC - Checking"] },
			{ name: "NL Savings", accounts: ["NL: Home Saving - S000"] },
			{ name: "Erin Savings", accounts: ["Erin: PNC - Savings"] },
			{ name: "Investments", accounts: ["NL: COIN", "NL: VAN"] },
			{ name: "Credit Line", accounts: ["NL: Home - CL"] },
			{ name: "Tax Estimate", accounts: ["NL: Tax Estimate"] },
		];

		const manualGroupConfig = [
			{ name: "Credit Cards", accounts: ["NL: Chase - Sapphire Preferred", "NL: Chase - United Explorer", "NL: Chase - Freedom", "NL: Chase - Ink Bold Preferred", "NL: Chase - United Business", "Erin: Chase - Sapphire Preferred", "Erin: PNC - Points Credit Card", "Erin: PNC - CashBack Credit Card"] },
			{ name: "Business Checking", accounts: ["NL: Immerge Checking"] },
			{ name: "Checking", accounts: ["NL: Checking - D100", "NL: Cash", "Erin: PNC - Checking"] },
			{ name: "Savings", accounts: ["Erin: PNC - Savings", "NL: Immerge Saving", "NL: Home Saving - S000"] },
			{ name: "Investments", accounts: ["NL: COIN", "NL: VAN"] },
			{ name: "Credit Line", accounts: ["NL: Home - CL"] },
			{ name: "Tax Estimate", accounts: ["NL: Tax Estimate"] },
		];

		accounts.forEach((item) => {
			const group = item.group || "Ungrouped"; // fallback if no group
			if (!groupedAccounts[group]) {
				groupedAccounts[group] = {
					group: group,
					accounts: [],
					total: 0,
				};
			}

			const latestEntry = data.filter((d) => d.account === item.account).sort((a, b) => new Date(b.date) - new Date(a.date))[0];

			if (latestEntry) {
				item.total = latestEntry.value;
			} else {
				item.total = 0;
			}

			groupedAccounts[group].accounts.push(item);
			groupedAccounts[group].total += item.total;
		});

		console.log(groupedAccounts);

		// Convert object to array
		setAccountDetails(Object.values(groupedAccounts));

		// Build a quick lookup of totals by account identifier
		const accountToTotal = {};
		Object.values(groupedAccounts).forEach((grp) => {
			grp.accounts.forEach((acc) => {
				accountToTotal[acc.account] = acc.total || 0;
			});
		});

		// Compute manual category -> subcategory (accounts) -> totals
		const manual = manualGroupConfig.map((grp) => {
			const subcategories = grp.accounts.map((accName) => ({
				account: accName,
				total: accountToTotal[accName] || 0,
			}));
			const total = subcategories.reduce((s, x) => s + x.total, 0);
			return {
				name: grp.name,
				subcategories,
				total,
			};
		});

		setManualGroups(manual);
		console.log("Manual Groups:", manual);
	}, [data]);

	return (
		<div className="accounts">
			<div className="links">
				<div className="l-btn" onClick={() => navigate("/accountBalance")}>
					All Account Balances
				</div>
				<Link to="/addAccountBalance" className="l-btn">
					Add Single
				</Link>
				<Link to={`/addAccountBalances/${"NL"}`} className="l-btn">
					Add NL
				</Link>
				<Link to={`/addAccountBalances/${"Erin"}`} className="l-btn">
					Add Erin
				</Link>
			</div>
			<div className="card-layout quarters">
				<div className="card full-width light total">
					<div className="table horizontal">
						<div className="row hd sm">
							{manualGroups &&
								manualGroups.map((grp, idx) => (
									<div className="col" key={`hdr-${idx}`}>
										<p className="sm">{grp.name}</p>
									</div>
								))}
							<div className="col total">
								<p className="sm">Total</p>
							</div>
						</div>
						<div className="row">
							{manualGroups &&
								manualGroups.map((grp, idx) => (
									<div className="col" key={`val-${idx}`}>
										<p>
											{Math.round(grp.total).toLocaleString("en-US", {
												style: "currency",
												currency: "USD",
												minimumFractionDigits: 0,
												maximumFractionDigits: 0,
											})}
										</p>
									</div>
								))}
							<div className="col total">
								<p>
									{Math.round(manualGroups.reduce((s, x) => s + x.total, 0)).toLocaleString("en-US", {
										style: "currency",
										currency: "USD",
										minimumFractionDigits: 0,
										maximumFractionDigits: 0,
									})}
								</p>
							</div>
						</div>
					</div>
				</div>
				{accountDetails.map((item, idx) => (
					<div className="card light" key={idx}>
						<p className="eyebrow">{item.group}</p>
						<div className="table vertical">
							{item.accounts.map((account, idx) => (
								<div className="row" key={idx}>
									<div className="hd col">
										<p>{account.name}</p>
									</div>
									<div className={`${account.total < 0 ? "col red" : "col"} ${account.total === 0 ? "col zero" : "col"}`}>
										<p>{Math.round(account.total).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 })}</p>
									</div>
								</div>
							))}

							<div className="row">
								<div className="col">
									<p>Total</p>
								</div>
								<div className="col">
									<p>{Math.round(item.total).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 })}</p>
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default SpendingAverages;
